var _ = require('underscore');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="container" style="background-image: url(\'images/assan/bg6.png\')"> <div class="float-sm-right"> <ul class="list-inline mb0"> <li class="list-inline-item"> <a href="'+
((__t=( resources['X100640'] ))==null?'':__t)+
'" class="social-icon-sm si-gray si-gray-round si-facebook"> <i class="fab fa-facebook-f"></i> <i class="fab fa-facebook-f"></i> </a> </li>  </ul> </div> <div class="float-sm-left"> <ul class="list-inline mb0 links"> <li class="list-inline-item"><a id="header_btnAuthLogoff" href="#btnAuthLogoff">'+
((__t=( resources['X100695'] ))==null?'':__t)+
'</a></li> <li class="list-inline-item"><a a id="header_btnAuth">'+
((__t=( resources['X100601'] ))==null?'':__t)+
'</a></li> <li class="list-inline-item"><a a id="header_btnAuthPortal" href="portal.html">'+
((__t=( resources['X100069'] ))==null?'':__t)+
'</a></li> <li class="list-inline-item"><a a id="header_li_price" href="#price">'+
((__t=( resources['X100602'] ))==null?'':__t)+
'</a></li> <li class="list-inline-item"><a a id="header_btnForgotPassword" href="#btnForgotPassword">'+
((__t=( resources['X100901'] ))==null?'':__t)+
'</a></li>  </ul>  </div> </div>';
}
return __p;
};
